import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Ô",
  "use": "icon-Ô-usage",
  "viewBox": "0 0 61 60",
  "content": "<symbol viewBox=\"0 0 61 60\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-Ô\">\n<path d=\"M14.7168 43.816L30.7008 17.608L46.6848 43.816H14.7168ZM51.2928 44.632L32.1888 13.336C31.5648 12.328 29.8848 12.328 29.2608 13.336L10.1568 44.632C9.82085 45.16 9.82085 45.832 10.1088 46.36C10.4448 46.936 11.0208 47.272 11.6448 47.272H49.8048C50.4288 47.272 51.0048 46.936 51.2928 46.36C51.6288 45.832 51.6288 45.16 51.2928 44.632Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol